import { Route, Routes } from 'react-router-dom'

import TabContent from './TabContent'
import UsersEdit from './UsersEdit'
import UsersImport from './UsersImport'
import UsersList from './UsersList'
import UsersNew from './UsersNew'

export default function UsersConfig() {
  const readerHelpIconProps = {
    builderPath: '/builder/ja-JP/ocr-reader-doc/user-settings.html#User',
    concurPath: '/concur/ja-JP/ocr-reader-doc/user-settings.html#User',
    invoicePath: '/invoice/ja-JP/ocr-reader-doc/user-settings.html#User',
    orderFormPath: '/order-form/ja-JP/ocr-reader-doc/user-settings.html#User',
  }

  return (
    <TabContent
      padding
      title="ユーザー設定"
      readerHelpIconProps={readerHelpIconProps}
      description="ユーザーの作成・編集・削除が可能です"
    >
      <Routes>
        <Route errorElement={<div />}>
          <Route index element={<UsersList />} />
          <Route path="new" element={<UsersNew />} />
          <Route path="import" element={<UsersImport />} />
          <Route path=":userId" element={<UsersEdit />} />
        </Route>
      </Routes>
    </TabContent>
  )
}
